import { Routes } from '@angular/router';
import { environment } from '../environments/environment';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      environment.isDemo
        ? import('./shared/components/theme/theme-demo-border/theme-demo-border.component').then(
            m => m.ThemeDemoBorderComponent
          )
        : import('./shared/components/theme/theme-dev/theme-dev.component').then(
            m => m.ThemeDevComponent
          ),
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./components/dashboard/dashboard.routes').then(
            r => r.dashboardRoutes
          ),
      },
      {
        path: 'sso',
        loadComponent: () =>
          import('./components/auth/sso/sso.component').then(
            m => m.SsoComponent
          ),
      },
      {
        path: 'accounts',
        loadChildren: () =>
          import('./components/accounts/accounts.routes').then(
            r => r.accountsRoutes
          ),
      },
      {
        path: 'subscriptions',
        loadChildren: () =>
          import('./components/subscriptions/subscriptions.routes').then(
            r => r.subscriptionsRoutes
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
